export class Attachment{
    fileName: string = "";
    fileSize: number = 0;
    fileType: string = "";   
    fileLocation: string = "";
}